import { useContext } from 'react'

import { ViewTypeContext } from '@/modules/shared/contexts/view-type/ViewTypeContext'
import { ViewType } from '@/modules/shared/types/ViewType'

/**
 * Custom hook to access the current view type from any component
 * @returns The current view type
 */
export function useViewType(): {
  viewType?: ViewType
  isUtility: boolean
  isPurchaser: boolean
  isSupplier: boolean
} {
  const context = useContext(ViewTypeContext)

  return {
    viewType: context,
    isUtility: context === ViewType.Utility,
    isPurchaser: context === ViewType.Purchaser,
    isSupplier: context === ViewType.Supplier,
  }
}
